import CommandIcon from "@/src/sb/components/icon/CommandIcon"
import KeyboardKeyKIcon from "@/src/sb/components/icon/KeyboardKeyKIcon"
import Search from "@/src/sb/components/icon/Search"
import SearchFunnelIcon from "@/src/sb/components/icon/SearchFunnelIcon"
import X from "@/src/sb/components/icon/X"
import classNames from "classnames"
import React, { ChangeEvent } from "react"

type SearchInputProps = {
  placeholder?: string
  className?: string
  onChange?: (data: ChangeEvent<HTMLInputElement>) => void
  value?: string
  alwaysShowClearIcon?: boolean
  onClick?: () => void
  readOnly?: boolean
  collapsed?: boolean
  cursorBehavior?: "default" | "pointer" | "not-allowed"
  ref?: React.Ref<HTMLInputElement>
  isSearchPage?: boolean
  onFilterToggle?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onClear?: () => void
}

const SearchInputV2 = React.forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      placeholder,
      className,
      onChange,
      value,
      onClick,
      readOnly,
      collapsed = false,
      alwaysShowClearIcon = false,
      cursorBehavior,
      isSearchPage = false,
      onFilterToggle,
      onClear
    }: SearchInputProps,
    ref
  ) => {
    const showClearIcon = alwaysShowClearIcon || !!value

    if (collapsed) {
      return (
        <button
          onClick={onClick}
          className={classNames(
            "flex items-center justify-center p-2",
            className
          )}
        >
          <Search size={16} />
        </button>
      )
    }

    return (
      <div className="flex w-full" onClick={onClick}>
        <div
          className={classNames(
            "relative flex items-center w-full px-5 py-3",
            className,
            {
              hidden: collapsed
            }
          )}
        >
          <span className="absolute left-3">
            <Search color={"#9CA3AF"} />
          </span>

          <input
            type="text"
            placeholder={placeholder}
            ref={ref}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
            className={classNames(
              "h-full block text-xs placeholder:text-white outline-none bg-inherit w-full pl-4 pr-10",
              {
                "cursor-pointer": cursorBehavior === "pointer",
                "cursor-not-allowed": cursorBehavior === "not-allowed"
              }
            )}
          />

          <div className="absolute right-3 flex items-center space-x-2">
            {showClearIcon ? (
              <button
                onClick={() => {
                  if (onClear) {
                    onClear()
                  } else if (onChange) {
                    onChange({
                      target: { value: "" }
                    } as ChangeEvent<HTMLInputElement>)
                  }
                }}
                className="flex items-center justify-center h-full"
                aria-label="clear search"
                type="button"
              >
                <X />
              </button>
            ) : (
              <div
                className="hidden md:flex items-center space-x-1"
                data-testid="command-icon"
              >
                <span className="flex items-center justify-center text-gray-400 text-xs border-[0.5px] border-gray-500 p-1 rounded-[2px]">
                  <CommandIcon />
                </span>
                <span
                  data-testId={"keyboard-key-k-icon"}
                  className="flex items-center justify-center text-gray-400 text-xs border-[0.5px] border-gray-500 p-1 rounded-[2px]"
                >
                  <KeyboardKeyKIcon />
                </span>
              </div>
            )}
          </div>
        </div>

        {isSearchPage && (
          <button
            className="bg-[#4B5563] flex items-center justify-center px-3 md:hidden"
            aria-label="Filter"
            type="button"
            onClick={onFilterToggle}
          >
            <SearchFunnelIcon />
          </button>
        )}
      </div>
    )
  }
)

export default SearchInputV2
